import { CSSResultGroup, TemplateResult, html, nothing } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property, state } from 'lit/decorators.js';
import componentStyles from './se-pre-footer.css.lit';
import '../se-background/se-background';
import { SlotController } from '../../controllers/slot-controller';

/**
 * The SePreFooter component
 * @element se-pre-footer
 */
@customElement('se-pre-footer')
export class SePreFooter extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, false);

  /**
   * Document property here
   */
  @property({ type: String, attribute: 'property-var' })
  propertyVar: string;

  @state() hasHeader: boolean;
  @state() hasBody: boolean;
  @state() hasCta: boolean;

  firstUpdated() {
    this.hasHeader = this.slots.test('header');
    this.hasBody = this.slots.test('body');
    this.hasCta = this.slots.test('cta');
  }

  render(): TemplateResult {
    return html`
      <se-background
        alignment="right"
        color="primary-2"
        curve-width="75"
        full-bleed
      >
        <div class="pre-footer--content">
          <div class="pre-footer--text">
            ${this.hasHeader ? html`<slot name="header"></slot>` : nothing}
            ${this.hasBody ? html`<slot name="body"></slot>` : nothing}
          </div>
          ${this.hasCta ? html` <slot name="cta"></slot>` : nothing}
        </div>
      </se-background>
    `;
  }
}
